module.exports = __webpack_public_path__ + "static/media/banner01.dfa8562c.jpg";